import { IZeosApiResponse } from "../contracts/ZeosApi";
import { getDataAsync, postDataAsync } from "../ZeosApiExecutor";
import { IAuth } from "./interfaces/IAuth";

export const Auth: IAuth = {
  loginUser: async (
    username: string,
    password: string
  ): Promise<IZeosApiResponse<any>> => {
    const response = await postDataAsync<any>("/Account/Login", {
      Username: username,
      Password: password,
    });

    return response;
  },

  logoutUser: async (): Promise<IZeosApiResponse<any>> => {
    const response = await getDataAsync<any>("/Account/Logout", "");
    return response;
  },
};
